// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__MwQYl","spin":"spinner_spin__y41Cf"};